import { render, staticRenderFns } from "./Recaptcha.vue?vue&type=template&id=6c60f636&"
import script from "./Recaptcha.vue?vue&type=script&lang=js&"
export * from "./Recaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6c60f636', component.options)
    } else {
      api.reload('6c60f636', component.options)
    }
    module.hot.accept("./Recaptcha.vue?vue&type=template&id=6c60f636&", function () {
      api.rerender('6c60f636', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pages/Login/Recaptcha.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Login/Recaptcha.vue
// module id = qs5x
// module chunks = 0